import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {PaymentRequestOnlineAttemptRepository} from './impl/service/ngrx/paymentRequestOnlineAttempt.repository';
import {PaymentRequestOnlineAttemptDataService} from './impl/service/ngrx/paymentRequestOnlineAttemptData.service';
import {PaymentRequestOnlineAttemptDataServiceAdapter} from './impl/service/ngrx/paymentRequestOnlineAttemptDataService.adapter';
import {PaymentRequestOnlineAttemptSummaryDataServiceAdapter} from './impl/service/ngrx/paymentRequestOnlineAttemptSummaryDataService.adapter';
import {errorMessages} from "../../../../core/error/errorMessages";

@NgModule({
    providers: [
        PaymentRequestOnlineAttemptRepository,
        PaymentRequestOnlineAttemptDataService,
        PaymentRequestOnlineAttemptDataServiceAdapter,
        PaymentRequestOnlineAttemptSummaryDataServiceAdapter,
    ],
})
export class PaymentRequestOnlineAttemptModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: PaymentRequestOnlineAttemptRepository,
                dataService: PaymentRequestOnlineAttemptDataService) {

        entityDataService.registerServices({
            PaymentRequestOnlineAttempt: dataService,
        });

        entityServices.registerEntityCollectionServices({
            PaymentRequestOnlineAttempt: repository,
        });

        errorMessages.set('SALE_PAYMENT_REQUEST_ONLINE_ATTEMPT_CARD_READER_NOT_PAIRED', 'Le lecteur de carte n\'est pas lié au compte.')
    }
}
